module.exports = __webpack_public_path__ + "static/media/upload.3d5afdda.svg";